import { z } from 'zod';

import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants/pagination';

import { zodInvoicesV2QueryParamsSchema } from '~/data/invoice';

const zodInvoiceV2OrderBySchema = z.enum([
  'receiptDate',
  'invoiceDate',
  'invoiceNumber',
  'grossAmount',
  'dueDate',
  'skontoDueDate',
  'netAmount',
  'taxAmount',
  'resultStatus',
  'source',
  'issuerName',
  'buyerName',
]);

export const validateInvoiceV2ListSearch = z.object({
  limit: zodInvoicesV2QueryParamsSchema.shape.limit.catch(
    PAGINATION_PAGE_SIZE_DEFAULT,
  ),
  orderBy: zodInvoiceV2OrderBySchema.catch('receiptDate'),
  page: z.number().int().min(0).catch(0),
  savedFilterId: z.uuid().optional().catch(undefined),
  sortOrder: zodInvoicesV2QueryParamsSchema.shape.sortOrder.catch('desc'),
});

export const defaultInvoiceV2ListSearch = validateInvoiceV2ListSearch.parse({});
